export const COLUNAS_DEFAULT_MODULE_TRATAMENTOS = [
  {
    module: 'TRATAMENTOS',
    colunas: [
      {
        field: 'numero',
        active: true,
        removable: true
      },
      {
        field: 'paciente.parceiro.nome_razao_social',
        active: true,
        removable: false
      },
      {
        field: 'plano_saude.descricao',
        active: true,
        removable: true
      },
      { field: 'valor_total', active: true, removable: true },
      { field: 'qtd_agendamentos_abertos', active: true, removable: true },
      { field: 'status', active: true, removable: true }
    ]
  }
];
